import PlantYogurtProduct from 'models/PlantYogurtProduct'

export const packagingInitialState = {
  category: PlantYogurtProduct.category,
  subCategory: PlantYogurtProduct.subCategory,
  VitaminD: PlantYogurtProduct.VitaminD,
  Sugar: PlantYogurtProduct.Sugar,
  Calcium: PlantYogurtProduct.Calcium,
  Protein: PlantYogurtProduct.Protein,
  SweetenerCertification: PlantYogurtProduct.SweetenerCertification,
  SugarCertification: PlantYogurtProduct.SugarCertification,
  CalciumCertification: PlantYogurtProduct.CalciumCertification,
  ProteinCertification: PlantYogurtProduct.ProteinCertification,
  PlantYogurtAltType: {
    value: PlantYogurtProduct.PlantYogurtAltType,
    label: 'Plant-Based Yogurt Alternative Type',
  },
  OtherPlantYogurtAltType: PlantYogurtProduct.OtherPlantYogurtAltType,
  FatLevel: {
    value: PlantYogurtProduct.FatLevel,
    label: 'Fat Level',
  },
  Flavor: {
    value: PlantYogurtProduct.Flavor,
    label: 'Flavor',
  },
  OtherFlavor: PlantYogurtProduct.OtherFlavor,
  PackageSize: PlantYogurtProduct.PackageSize,
  MultiPackageType: PlantYogurtProduct.MultiPackageType,
  MultiPackageCount: PlantYogurtProduct.MultiPackageCount,
}

export const plantYogurtAltTypeOptions = [
  { value: '', label: 'Plant-Based Yogurt Alternative Type', isDisabled: true },
  { value: 'Almond Milk', label: 'Almond Milk' },
  { value: 'Cashew Milk', label: 'Cashew Milk' },
  { value: 'Coconut Milk', label: 'Coconut Milk' },
  { value: 'Soy Milk', label: 'Soy Milk' },
  { value: 'Other', label: 'Other' },
]

export const fatLevelOptions = [
  { value: '', label: 'Fat Level', isDisabled: true },
  { value: 'Nonfat', label: 'Nonfat' },
  { value: 'Lowfat', label: 'Lowfat' },
  { value: 'Full fat', label: 'Full fat' },
]

export const flavorOptions = [
  { value: '', label: 'Flavor', isDisabled: true },
  { value: 'Plain', label: 'Plain' },
  { value: 'Strawberry', label: 'Strawberry' },
  { value: 'Vanilla', label: 'Vanilla' },
  { value: 'Other', label: 'Other' },
]
